<input type="file" [id]="customId" (change)="onFileSelected($event)" class="hidden" [accept]="extensionToValidate" multiple/>